import styled from 'styled-components';
import themeColors from 'styles/config/colors';
import sizes from 'styles/config/sizes';
import themeSpacing from 'styles/config/spacing';

import type { ToastType } from './types';

export const ToastContainer = styled.div<{ type?: ToastType }>`
  display: flex;
  gap: ${themeSpacing.xs3};
  align-items: flex-start;

  width: ${sizes.alertWidth}px;
  height: auto;
  padding: ${themeSpacing.sm1} ${themeSpacing.sm2};

  color: ${themeColors.textPrimaryInverse};
  white-space: pre-line;

  background-color: ${themeColors.backgroundInverse};
  border-radius: ${themeSpacing.radiusMedium};
`;

export const ToastIcon = styled.div`
  display: flex;
  align-items: center;
`;

export const ToastBody = styled.div`
  display: flex;
  flex-grow: 1;
  align-items: flex-start;

  p {
    width: 100%;
    word-break: break-word;
  }
`;

export const MessageContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: ${themeSpacing.xs1};
`;
